import React from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/src/types/general';
import { WarningFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types';
import {
  ValidationBlockStyled,
  ValidationTitleStyled,
  ValidationListStyled,
  ValidationTitleWrapperStyled,
} from './styled';

export interface ValidationErrorsProps extends ICustomizableElement, ITestingElement {
  title?: string;
  errors: string[];
}

const ValidationErrors: React.FC<ValidationErrorsProps> = ({
  title,
  errors,
  className,
  'data-test-id': dataTestId,
}) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <ValidationBlockStyled className={className} data-test-id={dataTestId}>
      {title && (
        <ValidationTitleWrapperStyled data-role="validation-title" data-test-for={dataTestId}>
          <WarningFilled
            width="2.4rem"
            height="2.4rem"
            color={colors.red[600]}
            data-role="warning-icon"
            data-test-for={dataTestId}
          />
          <ValidationTitleStyled>{title}</ValidationTitleStyled>
        </ValidationTitleWrapperStyled>
      )}
      <ValidationListStyled>
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ValidationListStyled>
    </ValidationBlockStyled>
  );
};

export default ValidationErrors;
